export const forgotPasswordConstants = {
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  CLEAR_ERROR: 'sigin/CLEAR_ERROR',
};
